const Tabs = ({ t, setTab, tab }) => {
  const tabs = [
    {
      name: t("salariesList"),
      value: "salaries",
    },
    {
      name: t("financialEntitlements"),
      value: "entitlements",
    },
    {
      name: t("salariesRate"),
      value: "rate",
    },
  ];
  return (
    <section className="grid sm:w-[450px] grid-cols-1 my-4 overflow-hidden  sm:grid-cols-3 rounded-xl bg-primary">
      {tabs.map((t, i) => {
        const active = t.value === tab;

        return (
          <button
            className={`border-b-2  text-center py-4 font-semibold ${
              active ? "border-white" : "border-transparent"
            }`}
            onClick={() => setTab(t.value)}
            key={i}
          >
            {t.name}
          </button>
        );
      })}
    </section>
  );
};

export default Tabs;
